/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";

/**
 * Style dependencies
 */
import "./styles.scss";

const Placeholder = (props) => {
  return <Box className={"operation__upload-form-placeholder"} />;
};

export default Placeholder;
